import Client from './Client';

export default class StatisticsClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取统计
   */
  async getHomePageStatistics(data) {
    const res = await this.client.post('/api/statistics/getHomePageStatistics', data);
    return res;
  }
}